import Vue from 'vue';

const defaultErrorMessages = {
  401: 'Platnost přihlášení vypršela, obnovte, prosím, stránku.',
  403: 'Na tuto akci nemáte práva.',
  default: 'Něco se pokazilo. Obnovte, prosím, stránku a zkuste akci oprakovat.'
};

const showErrorMessage = (message) => {
  Vue.toasted.show(message, {
    type: 'error',
    position: 'top-right',
    duration: '5000'
  });
};

const handleError = (errorMessages = {}) => (error) => {
  const messages = { ...defaultErrorMessages, ...errorMessages };
  let message = messages[error.response.status] || messages['default'];

  showErrorMessage(message);

  return Promise.reject(error);
};

export { handleError };
